/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AdTargetAttributeSearchPathsEnum {
  BEHAVIORS = "BEHAVIORS",
  CITIES = "CITIES",
  COUNTRIES = "COUNTRIES",
  EDUCATION_MAJORS = "EDUCATION_MAJORS",
  EDUCATION_SCHOOLS = "EDUCATION_SCHOOLS",
  FAMILY_STATUSES = "FAMILY_STATUSES",
  INCOME = "INCOME",
  INTERESTS = "INTERESTS",
  LOCALES = "LOCALES",
  MEDIUM_GEO_AREAS = "MEDIUM_GEO_AREAS",
  REGIONS = "REGIONS",
  WORK_EMPLOYERS = "WORK_EMPLOYERS",
  WORK_POSITIONS = "WORK_POSITIONS",
  ZIPS = "ZIPS",
}

export enum AggregationPeriod {
  DAY = "DAY",
  DAYS_28 = "DAYS_28",
  MONTH = "MONTH",
  SEVEN_DAYS = "SEVEN_DAYS",
  TOTAL = "TOTAL",
  WEEK = "WEEK",
}

export enum ArticleExpirationSettingsRuleTypeEnum {
  from_keywee_creation_date = "from_keywee_creation_date",
  from_publish_date = "from_publish_date",
}

export enum AttributionWindow {
  click_1d = "click_1d",
  click_28d = "click_28d",
  click_28d_view_1d = "click_28d_view_1d",
  click_7d = "click_7d",
  default = "default",
  view_1d = "view_1d",
  view_28d = "view_28d",
  view_7d = "view_7d",
}

export enum BrandRuleTypeEnum {
  flag = "flag",
  not_generate = "not_generate",
}

export enum BreakdownEnum {
  age = "age",
  country = "country",
  device_platform = "device_platform",
  dma = "dma",
  gender = "gender",
  hourly_stats_aggregated_by_advertiser_time_zone = "hourly_stats_aggregated_by_advertiser_time_zone",
  impression_device = "impression_device",
  platform_position = "platform_position",
  product_id = "product_id",
  publisher_platform = "publisher_platform",
  region = "region",
}

export enum ContentGenerationUseCaseEnum {
  create_new_content = "create_new_content",
  improve_time_spend_on_page = "improve_time_spend_on_page",
}

export enum CreativePreviewFormat {
  DESKTOP_FEED_STANDARD = "DESKTOP_FEED_STANDARD",
  FACEBOOK_STORY_MOBILE = "FACEBOOK_STORY_MOBILE",
  INSTAGRAM_REELS = "INSTAGRAM_REELS",
  INSTAGRAM_STANDARD = "INSTAGRAM_STANDARD",
  INSTAGRAM_STORY = "INSTAGRAM_STORY",
  MESSENGER_MOBILE_INBOX_MEDIA = "MESSENGER_MOBILE_INBOX_MEDIA",
  MOBILE_FEED_STANDARD = "MOBILE_FEED_STANDARD",
  MOBILE_NATIVE = "MOBILE_NATIVE",
}

export enum CreativeReviewReason {
  bad_image = "bad_image",
  discard_story = "discard_story",
  other = "other",
  tone_and_style = "tone_and_style",
  typo_grammar = "typo_grammar",
  wrong_utm = "wrong_utm",
}

export enum CreativeReviewStatus {
  approved = "approved",
  disapproved = "disapproved",
  internally_disapproved = "internally_disapproved",
  need_of_client_approval = "need_of_client_approval",
  pending = "pending",
  pending_client_review = "pending_client_review",
  pending_client_review_and_upload = "pending_client_review_and_upload",
  pending_internal_approval = "pending_internal_approval",
  rejected = "rejected",
}

export enum CreativeSourceTypeEnum {
  keywee = "keywee",
  non_keywee = "non_keywee",
  none = "none",
}

export enum CreativeStatusEnum {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
  IN_PROCESS = "IN_PROCESS",
  OVERDUE = "OVERDUE",
  PAUSED = "PAUSED",
  WITH_ISSUES = "WITH_ISSUES",
}

export enum DevicePlatformsEnum {
  desktop = "desktop",
  mobile = "mobile",
}

export enum FacebookPositionsEnum {
  feed = "feed",
  instant_article = "instant_article",
  marketplace = "marketplace",
  right_hand_column = "right_hand_column",
  story = "story",
}

export enum GenderEnum {
  any = "any",
  female = "female",
  male = "male",
}

export enum GenerateIdeationsUseCaseEnum {
  generate_keyword_ideations_from_text = "generate_keyword_ideations_from_text",
  generate_story_headline_ideations_from_text = "generate_story_headline_ideations_from_text",
  generate_story_headline_ideations_from_urls = "generate_story_headline_ideations_from_urls",
}

export enum ImageTypeEnum {
  ai_image = "ai_image",
  article_image = "article_image",
  from_post = "from_post",
  manual = "manual",
}

export enum IndexSortMetricEnum {
  avg_eng_time_per_session = "avg_eng_time_per_session",
  bounce_rate = "bounce_rate",
  sessions = "sessions",
}

export enum IndexSourceEnum {
  ga = "ga",
  manual = "manual",
  pixel = "pixel",
}

export enum InstagramPositionsEnum {
  reels = "reels",
  story = "story",
  stream = "stream",
}

export enum MessengerPositionsEnum {
  messenger_home = "messenger_home",
  story = "story",
}

export enum MetricKeys {
  HighestScalingStory = "HighestScalingStory",
  TopDemographicOfTopStory = "TopDemographicOfTopStory",
  TopEngagementCreative = "TopEngagementCreative",
  TopPerformingCampaign = "TopPerformingCampaign",
  TopPerformingCreative = "TopPerformingCreative",
  TopPerformingStory = "TopPerformingStory",
}

export enum OrganicUploadSettingsCreativeCallToActionEnum {
  APPLY_NOW = "APPLY_NOW",
  BOOK_TRAVEL = "BOOK_TRAVEL",
  DOWNLOAD = "DOWNLOAD",
  GET_OFFER = "GET_OFFER",
  GET_QUOTE = "GET_QUOTE",
  LEARN_MORE = "LEARN_MORE",
  SIGN_UP = "SIGN_UP",
  SUBSCRIBE = "SUBSCRIBE",
}

export enum OrganicUploadSettingsTypeEnum {
  performance = "performance",
  rss_direct = "rss_direct",
  rss_organic = "rss_organic",
}

export enum PublisherPlatformsEnum {
  audience_network = "audience_network",
  facebook = "facebook",
  instagram = "instagram",
  messenger = "messenger",
}

export enum ReportLevelEnum {
  article = "article",
  campaign = "campaign",
}

export enum SelfServiceCampaignUseCaseEnum {
  ADS_ARBITRAGE = "ADS_ARBITRAGE",
  AUDIENCE_DEVELOPMENT = "AUDIENCE_DEVELOPMENT",
  BRANDED_CONTENT = "BRANDED_CONTENT",
  E_COMMERCE = "E_COMMERCE",
  SUBSCRIPTIONS = "SUBSCRIPTIONS",
}

export enum StorySpendStatus {
  ACTIVE = "ACTIVE",
  PAUSED = "PAUSED",
}

export enum TimeIntervalEnum {
  daily = "daily",
  monthly = "monthly",
  total = "total",
  weekly = "weekly",
}

export enum UseCase {
  AdRevenue = "AdRevenue",
  AudienceDevelopment = "AudienceDevelopment",
  BrandedContent = "BrandedContent",
  Ecommerce = "Ecommerce",
  GoogleDemandGen = "GoogleDemandGen",
  PaidSubscriptions = "PaidSubscriptions",
}

export enum UserDeviceEnum {
  android_smartphone = "android_smartphone",
  android_tablet = "android_tablet",
  ipad = "ipad",
  iphone = "iphone",
}

export enum UserOsEnum {
  android = "android",
  iOS = "iOS",
}

export enum UserType {
  CSM = "CSM",
  Publisher = "Publisher",
}

export interface ArticleExpirationSettingsExpirationRulesInput {
  id?: string | null;
  duration?: number | null;
  utmKey?: string | null;
  utmValue?: string | null;
}

export interface ArticleExpirationSettingsInput {
  id?: string | null;
  enabled?: boolean | null;
  defaultDuration?: number | null;
  ruleType?: ArticleExpirationSettingsRuleTypeEnum | null;
  expirationRulesAttributes?: ArticleExpirationSettingsExpirationRulesInput[] | null;
}

export interface ArticleInput {
  url: string;
  title: string;
  description: string;
}

export interface AudienceAlignmentContentParamsInput {
  text?: string | null;
  keywords?: string[] | null;
  personaId: string;
  toneOfVoiceId?: string | null;
}

export interface BrandRuleInput {
  id?: string | null;
  term: string;
  type: BrandRuleTypeEnum;
  enabled: boolean;
  replaceTerm?: string | null;
  description: string;
}

export interface CampaignFacebookPageInput {
  facebookPageId: any;
  facebookPageDisplayName: string;
  instagramAccountType?: string | null;
  instagramAccountId?: any | null;
  newPageExperience?: boolean | null;
}

export interface CommerceContentParamsInput {
  products: CommerceContentProductInput[];
  headline?: string | null;
  toneOfVoiceId?: string | null;
  personaId?: string | null;
}

export interface CommerceContentProductInput {
  name: string;
  description: string;
  isLong: boolean;
}

export interface ContentParamsInput {
  text: string;
  keywords?: string[] | null;
  wordsCount?: number | null;
  description?: string | null;
  headline?: string | null;
  domain?: string | null;
  toneOfVoiceId?: string | null;
  personaId?: string | null;
}

export interface CreativeReviewCommentsInput {
  generalComment?: string | null;
  postText?: string | null;
  headline?: string | null;
  description?: string | null;
}

export interface CreativeReviewFilterInput {
  publisherId: string;
  useCases: UseCase[];
  reviewStatuses: CreativeReviewStatus[];
  campaignIds?: string[] | null;
  storyIds?: string[] | null;
  reviewTime?: DateTimeRangeInput | null;
}

export interface DateRangeInput {
  startDate: any;
  endDate: any;
}

export interface DateTimeRangeInput {
  from?: any | null;
  to?: any | null;
}

export interface IndexConfigInput {
  file?: any | null;
  source: IndexSourceEnum;
  domain: string;
  sortMetric: IndexSortMetricEnum;
  discardedAt?: string | null;
}

export interface JobInput {
  publisherId: string;
  startDate: any;
  endDate: any;
  timeInterval: TimeIntervalEnum;
  breakdowns: BreakdownEnum[];
  attributionWindow: AttributionWindow;
  reportLevel: ReportLevelEnum;
  campaignUseCase?: UseCase | null;
  campaignIds?: string[] | null;
  articleIds?: string[] | null;
}

export interface OrganicUploadSettingsInput {
  id?: string | null;
  enabled?: boolean | null;
  type?: string | null;
  maxArticlesToUpload?: number | null;
  enableCreativeApproval?: boolean | null;
  enableCreativeSuggestions?: boolean | null;
  maxCreativeSuggestions?: number | null;
  excludeTaggedSponsoredPosts?: boolean | null;
  enablePoliticalContent?: boolean | null;
  enableLeadgenFormCreation?: boolean | null;
  enableLeadgenFormNamePrefix?: boolean | null;
  leadgenFormExternalId?: string | null;
  creativeCallToAction?: OrganicUploadSettingsCreativeCallToActionEnum | null;
  leadgenFormNamePrefix?: string | null;
  rssSettings?: OrganicUploadSettingsRssSettingsInput[] | null;
  whitelistEnabled?: boolean | null;
  whitelistedWords?: string[] | null;
  blacklistEnabled?: boolean | null;
  blacklistedWords?: string[] | null;
}

export interface OrganicUploadSettingsRssSettingsInput {
  url: string;
  startDate: any;
}

export interface PersonaInput {
  id?: string | null;
  name: string;
  interests: string[];
  default: boolean;
  gender: GenderEnum;
  minAge: number;
  maxAge: number;
}

export interface SelfServiceCampaignInput {
  name: string;
  end: any;
  useCase?: SelfServiceCampaignUseCaseEnum | null;
  defaultDailyBudget: number;
  defaultObjective: string;
  optimizationGoal?: string | null;
  defaultArbitrageOptimizationStrategy?: string | null;
  whitelistDomains?: string | null;
  utmParameters?: string | null;
  adMacroTags?: string | null;
  whitelistedUrlParams?: string | null;
  urlSegment?: string | null;
  campaignFacebookPages: CampaignFacebookPageInput[];
  unifiedTrackingPixels?: any[] | null;
  automaticAdPlacementEnabled?: boolean | null;
  defaultPlacementPublisherPlatforms?: PublisherPlatformsEnum[] | null;
  defaultPlacementDevicePlatforms?: DevicePlatformsEnum[] | null;
  defaultPlacementFacebookPositions?: FacebookPositionsEnum[] | null;
  defaultPlacementInstagramPositions?: InstagramPositionsEnum[] | null;
  defaultPlacementMessengerPositions?: MessengerPositionsEnum[] | null;
  defaultUserDevice?: UserDeviceEnum[] | null;
  defaultUserOs?: UserOsEnum[] | null;
  defaultAgeMin?: number | null;
  defaultAgeMax?: number | null;
  defaultGender?: number | null;
  language: string;
  defaultLocalesFromLanguage?: boolean | null;
  defaultCountries?: string[] | null;
  defaultRegions?: any[] | null;
  defaultMediumGeoAreas?: any[] | null;
  defaultCities?: any[] | null;
  defaultZipCodes?: any[] | null;
  defaultBehaviors?: any[] | null;
  defaultCustomAudiences?: any[] | null;
  excludedCustomAudiences?: any[] | null;
  defaultRelationshipStatuses?: number[] | null;
  articleExpirationSettingsAttributes?: ArticleExpirationSettingsInput | null;
  organicUploadSettingsAttributes?: OrganicUploadSettingsInput | null;
}

export interface ToneOfVoiceInput {
  id?: string | null;
  name: string;
  description: string;
  default?: boolean | null;
}

export interface UserPublisherPermissionsInput {
  publisherId: string;
  useCases: string[];
  manageApiAccess: boolean;
  allowCreativeApproval?: boolean | null;
  receiveCreativeReviewEmails?: boolean | null;
  contentEnhancerAdmin?: boolean | null;
}

export interface WorkspaceParamsInput {
  name: string;
  reportsExternalUserIds?: string[] | null;
  domains: string[];
  indexConfigs?: IndexConfigInput[] | null;
  toneOfVoices: ToneOfVoiceInput[];
  personas: PersonaInput[];
  brandRules: BrandRuleInput[];
}

//==============================================================
// END Enums and Input Objects
//==============================================================
